import Button from '@mui/material/Button';

const CreatePlusIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
		<path d="M10 4.16675V15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
		<path d="M4.16675 10H15.8334" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const HeaderCreateButton = ({ onCreateHandler, activeCreateButton = false }) => {
	return (
		<Button
			type="button"
			onClick={onCreateHandler}
			disabled={activeCreateButton}
			startIcon={<CreatePlusIcon />}
			sx={{
				height: '36px',
				px: 2,
				gap: 0.75,
				color: '#FFFFFF',
				fontSize: '14px',
				fontWeight: 500,
				lineHeight: '20px',
				boxShadow: 'none',
				borderRadius: '10px',
				textTransform: 'none',
				border: '1px solid #155DFC',
				backgroundColor: '#155DFC',
				'& .MuiButton-startIcon': {
					margin: 0,
				},
				'&:hover': {
					boxShadow: 'none',
					backgroundColor: '#0E4FD5',
					borderColor: '#0E4FD5',
				},
				'&.Mui-disabled': {
					color: '#E2E8F0',
					borderColor: '#93C5FD',
					backgroundColor: '#93C5FD',
				},
			}}
		>
			Create
		</Button>
	);
};

export default HeaderCreateButton;
